// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ov-6";
export var imgContainer = "_ov-3";
export var menuIcon = "_ov-5";
export var pillWrapper = "_ov-2";
export var pillsContainer = "_ov-1";
export var subscriptionCard = "_ov-0";
export var subscriptionLogo = "_ov-4";